import experiments from '@reverbdotcom/commons/src/experiments';
import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

export const ALWAYS_TRACKED_EXPERIMENTS = [
  experiments.LISTING_CARD_LOCATION,
  experiments.DUMMY,
  experiments.MV_DUMMY_COOKIE_BUCKETING,
  experiments.MARKETPLACE_GRID_ADS,
  experiments.LIKELIHOOD_TO_SELL_V3_INTERNATIONAL,
  experiments.AA_MARKETPLACE_SESSION_BUCKETING,
];

interface PageViewTrackedExperimentsParams {
  pageName?: MParticlePageName;
  user?: Partial<IUser>;
}

export function pageViewTrackedExperiments({
  user,
  pageName,
}: PageViewTrackedExperimentsParams): string[] {
  const searchRelevanceExperiments = (user?.experiments?.filter(exp => exp.use_in_marketplace_listings_search) || []).map(exp => exp.name);
  const trackedExperiments = searchRelevanceExperiments.concat(ALWAYS_TRACKED_EXPERIMENTS);

  if (pageName === MParticlePageName.Marketplace) {
    trackedExperiments.push(experiments.SRP_EXPOSED_FILTERS);
  }

  return trackedExperiments;
}
